<template>
  <div class="p-0">
    <dod-border-section class="flex" style="align-items: center; gap: 10px">
      <template v-slot:section-slot>
        <strong>{{ title }}</strong>
        <span>
          {{ optionsToDisplay }}
        </span>
        <custom-button
          size="small"
          title="Edytuj"
          :white="true"
          style="margin-left: auto"
          @click="handleEditClick()"
        />
      </template>
    </dod-border-section>
  </div>
</template>

<script>
import DodBorderSection from "./DodBorderSection.vue";
import CustomButton from "../CustomButton.vue";
export default {
  components: {
    DodBorderSection,
    CustomButton,
  },

  data() {
    return {
      optionsToDisplay: "",
    };
  },

  props: {
    title: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    settingKey: {
      type: String,
      default: "",
    },
  },

  emits: ["onEdit"],

  methods: {
    handleEditClick() {
      this.$emit("onEdit", {
        key: this.settingKey,
        title: this.title,
        options: this.options,
      });
    },
    parseOptionsToString() {
      if (this.options) {
        this.optionsToDisplay = this.options
          .reduce(
            (finalString, option) => (finalString += ` ${option.name},`),
            ""
          )
          .slice(0, -1);
      }
    },
  },

  watch: {
    options() {
      this.parseOptionsToString();
    },
  },

  created() {
    this.parseOptionsToString();
  },
};
</script>

<style scoped>
section {
  padding-left: 5px;
}
strong {
  font-size: 18px;
  font-weight: 600;
  color: #090741;
}
strong,
span {
  height: fit-content;
}
span {
  font-size: 14px;
  line-height: 18px;
}
</style>
